import { useEffect, useState } from 'react'
import './ConfirmAppointment.scss'
import { ErrorModal, Loader, Modal, SuccessModal } from 'medere-ui-framework';
import { Button } from 'primereact/button';
import { useIntl } from 'react-intl';
import { confirmAppointment, getAppointmentInformationForConfirm} from '../../services/AppointmentService';
import InfoCard from '../../components/InfoCard/InfoCard';
import { HttpStatusCode } from 'axios';
import { EAppointmentState, EAppointmentStateValues, getAppointmentStateStringById } from '../../enums/EAppointmentState';

export default function ConfirmAppointment() {

  const [responseData,setResponseData]:any=useState(null);

  const [,setShowErrorModal]=useState(false);
  const [appointmentState, setAppointmentState] = useState<number>(0);
  const intl = useIntl();

  const [showCannotConfirmAppointmentModal,setShowCannotConfirmAppointmentModal]=useState(false);
  const [showAppointmentConfirmed,setShowAppointmentConfirmed]=useState(false);
  const [showAppointmentConfirmedProblem,setShowAppointmentConfirmedProblem]=useState(false);

  const [showLoader,setShowLoader]=useState(false);
  const [siteLogo]=useState("");

  useEffect(()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const appID = urlParams.get('appID'); 
    const me = urlParams.get('me'); 

    if(appID && me){
        getAppointmentInformationForConfirm(appID,me).then(res=>{
          setAppointmentState(res.data.state);
          if(res.status===200){
            if(res.data.state!=EAppointmentStateValues[EAppointmentState.SCHEDULLED])
              setShowCannotConfirmAppointmentModal(true)
            else
              setShowErrorModal(false);
            setResponseData(res.data)
          }else{
            setShowErrorModal(true)
          }
      });
     
    }
    
  },[])

  function confirm_Appointment(){
    setShowLoader(true)
    confirmAppointment(responseData.pcq).then(res=>{
      if(res.status==HttpStatusCode.Ok){
        //se cancelo correctamente
        setShowLoader(false)
        setShowAppointmentConfirmed(true);
      }else{
        //ocurrio un error en medere al confirmar el turno
        setShowLoader(false)
        setShowAppointmentConfirmedProblem(true)
      }
    }).catch(()=>{setShowLoader(false)})
  }
  function closeWindow(){
      window.close()
  }

  return (
    <div className='flexible--column width-100 height-100 cancel-view-container viewContainer'>
        {(responseData && !showCannotConfirmAppointmentModal) && <div className='flexible--column cancel-container'>
        {siteLogo && <img style={{borderRadius:'8px',marginBottom:'16px',width:'100px',height:'100px'}} src={siteLogo} alt="logo" 
        className='logoSite' />}
          {showLoader && <Loader className="warningSpinner" size={24}/> }
          <div className='flexible-row content'>
            <h3 style={{marginBottom:'16px'}}>{intl.formatMessage({id:"AppointmentConfirmation"})}</h3>
            
            <InfoCard textClassName={"textBold infoText"} icon="vaadin:doctor" label={intl.formatMessage({id:"Professional"})} text={responseData.professional}></InfoCard>
            { responseData.speciality!="" && <InfoCard textClassName={"textBold infoText"} icon="vaadin:stethoscope" label={intl.formatMessage({id:"Speciality"})} text={responseData.speciality}></InfoCard>}
            <InfoCard textClassName={"textBold infoText"} icon="vaadin:calendar" label={intl.formatMessage({id:"Date"})} text={intl.formatDate(responseData.date,{weekday:'long',hour:'2-digit',minute:'2-digit',day:'2-digit',month:'2-digit',year:'numeric'})}></InfoCard>
            
            <div style={{marginTop:'8px',justifyContent:'center',alignItems:'center'}} className='flexible--row'>
              <Button className='buttonMain' onClick={closeWindow}>{intl.formatMessage({id:"Back"})}</Button>
              <Button className='buttonMain' onClick={confirm_Appointment}>
                {showLoader ? <Loader className="warningSpinner" size={24}/> : intl.formatMessage({id:"Yes"})+", " + intl.formatMessage({id:"Confirm"}) }
                </Button>
            </div>
          </div>
        </div>}
        <Modal visible={showCannotConfirmAppointmentModal} setVisible={setShowCannotConfirmAppointmentModal} header={intl.formatMessage({id:"Attention"})}
        onHideCustom={closeWindow} >
        {intl.formatMessage({id:"CannotConfirmMessage"}).replace("[APPOINTMENTSTATE]",intl.formatMessage({id:getAppointmentStateStringById(appointmentState)}))}
        </Modal>
        <SuccessModal visible={showAppointmentConfirmed} setVisible={setShowAppointmentConfirmed} header={intl.formatMessage({id:"AppointmentConfirmed"})} onHide={closeWindow}>
        </SuccessModal>
        <ErrorModal visible={showAppointmentConfirmedProblem} setVisible={setShowAppointmentConfirmedProblem} header={intl.formatMessage({id:"AppointmentConfirmedProblem"})}>
        </ErrorModal>
    </div>
  )
}
